<template>
  <div class="week-to-print">
    <div class="week-to-print__header">
      <change-school-year :whiteTheme="true"></change-school-year>
    </div>
    <div class="weeks-container">
      <ul class="weeks">
        <template v-if="weeks.length < 1">
          <Spinner color="blue" style="margin-bottom: 100px"></Spinner>
        </template>
        <template v-else>
          <li class="weeks__week hint--top"
              v-for="week in weeks"
              :key="week.serverDate"
              :aria-label="tooltipDate(week.date)"
              @click="setSelectedWeek(week)">
            {{ showWeek(week.date) }}
            <span class="weeks__week__now-indicator" v-if="isNow(week)"></span>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ChangeSchoolYear from '../School/ChangeSchoolYear'

export default {
  components: {ChangeSchoolYear},
  computed: {
    activeSchoolYears () {
      return this.$store.state.activeSchoolYears
    },
    localActivatedSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    weeks () {
      let activeSchoolYear = this.localActivatedSchoolYear
      if (this.calType === 'klass') {
        this.calStartDate = activeSchoolYear.student_time_start
        this.calEndDate = activeSchoolYear.student_time_end
      } else {
        this.calStartDate = activeSchoolYear.employee_time_start
        this.calEndDate = activeSchoolYear.employee_time_end
      }
      const start = moment(this.calStartDate).startOf('isoweek')
      const end = moment(this.calEndDate).endOf('isoweek')
      let startWeek = moment(start).isoWeek()
      let diff = moment(end).diff(start, 'week')
      let max = startWeek + diff
      let weeks = []
      for (let i = startWeek; i <= max; i++) {
        let date = moment(start).isoWeek(i)
        weeks.push({
          date: date,
          serverDate: moment(date).format('GGGG-WW'),
          weekNum: date.isoWeek()
        })
      }
      return weeks
    }
  },
  methods: {
    tooltipDate (date) {
      let start = moment(date).startOf('isoweek')
      let start2 = moment(date).startOf('isoweek').format('DD. MMM')
      let startFormat = start.format('DD')
      let end = moment(date).endOf('isoweek')
      let endFormat = moment(date).endOf('isoweek').format('DD. MMM YYYY')
      // If same month
      if (moment(start).format('MM') === moment(end).format('MM')) {
        return startFormat + ' - ' + endFormat
      } else {
        return start2 + ' - ' + endFormat
      }
    },
    isNow (week) {
      return moment(week.date).format('GGGG-WW') === moment().format('GGGG-WW')
    },
    setSelectedWeek (week) {
      this.$emit('setWeek', week)
    },
    showWeek (date) {
      return moment(date).isoWeek()
    }
  }
}
</script>

<style scoped>

.weeks {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  min-width: 418px;
  padding: 3px;
  margin-top: 0;
}

.weeks__week {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  height: 42px;
  width: 42px;
  margin: 2px;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid #edf0f5;
  user-select: none;
  transition: all .25s;
}

.weeks-container {
  width: 550px;
  background: #ffffff;
  padding: 2rem 0;
}

.weeks__week:hover {
  border-color: var(--blue);
}

.weeks__week:active {
  transform: scale(0.9);
}

.weeks__week--is-selected {
  background-color: #468ad7;
  color: #fff;
}

.week-to-print__header {
  display: flex;
  justify-content: flex-start;
  margin: 0 0 1rem 1rem;
}

</style>



// WEBPACK FOOTER //
// PrintCalendarsWeekSelector.vue?4e340d1d